import { useCallback, useEffect, useRef } from 'react'

const ALARM_SOUND_URL = '/sounds/alarm.ogg'

export const useAlarmSound = () => {
  const audioRef = useRef<HTMLAudioElement | null>(null)

  useEffect(() => {
    audioRef.current = new Audio(ALARM_SOUND_URL)
    return () => {
      audioRef.current = null
    }
  }, [])

  const playAlarmSound = useCallback(() => {
    if (!audioRef.current) return
    // Reset to start in case the previous play hasn't finished.
    audioRef.current.currentTime = 0
    audioRef.current.play().catch(() => {
      // Browser autoplay policy may block playback — silently ignore.
    })
  }, [])

  return { playAlarmSound }
}
